export default __webpack_public_path__ + "static/locked-phone-0a710ab1de204ee52b1a3581986a1aff.png";